import React, {ReactNode} from 'react'
import {Lang} from 'yougile-lang'
import {Loading} from '@components/common/loading/loading'
import IconLetter from './icon-letter.svg'
import {useEmailChange} from './use-email-change'

interface ContentWrapperProps {
  children: ReactNode
}

const ContentWrapper = ({children}: ContentWrapperProps) => (
  <div className="msp">
    <a className="msp-logo" href="/" />
    <div className="msp-wnd flex justify-center">
      <div className="flex flex-col items-center justify-center gap-16">
        {children}
      </div>
    </div>
  </div>
)

const LoadingPage = () => (
  <ContentWrapper>
    <Loading />
  </ContentWrapper>
)

const SuccessPage = () => (
  <ContentWrapper>
    <IconLetter className="flex-base" />
    <span className="flex-base font-semibold">
      {Lang.msg.profilePage.emailChangeSuccess}
    </span>
  </ContentWrapper>
)

const FailPage = () => (
  <ContentWrapper>
    <span className="flex-base font-semibold">
      {Lang.msg.profilePage.emailChangeFail}
    </span>
  </ContentWrapper>
)

export const EmailChangePage = () => {
  const state = useEmailChange()

  switch (state) {
    case 'pending':
      return <LoadingPage />
    case 'success':
      return <SuccessPage />
    case 'fail':
      return <FailPage />
    default:
      return null
  }
}
